import { Action, Dispatch } from 'redux'
import { initStoreDeliveryBreadAction } from 'reducks/storeDeliveryBread/actions'

const initStoreDeliveryBread = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(initStoreDeliveryBreadAction())
  }
}

export default initStoreDeliveryBread
